import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGlobalStylesFields, getGlobalStylesOverrides, getGlobalStylesFetchStatus } from 'ContentData/selectors/globalStyles';
import * as GlobalStylesActions from 'ContentData/actions/GlobalStyles';
import * as RequestStatuses from 'ContentUtils/constants/RequestStatus';
import { buildCollectionMap } from 'ContentComponents/components/cmv2/utils/bindingResolution';
const EMPTY_MAP = {};
export function useGlobalStylesCollectionData(enabled = true) {
  const dispatch = useDispatch();
  const gsFields = useSelector(state => enabled ? getGlobalStylesFields(state) : undefined);
  const gsOverrides = useSelector(state => enabled ? getGlobalStylesOverrides(state) : undefined);
  const requestStatus = useSelector(state => enabled ? getGlobalStylesFetchStatus(state) : undefined);
  useEffect(() => {
    if (enabled && requestStatus === RequestStatuses.UNINITIALIZED) {
      void dispatch(GlobalStylesActions.fetchGlobalStyles({
        bufferTheme: true
      }));
    }
  }, [enabled, requestStatus, dispatch]);
  const isReady = enabled ? requestStatus === RequestStatuses.SUCCEEDED : false;
  const isLoading = enabled ? requestStatus !== RequestStatuses.SUCCEEDED && requestStatus !== RequestStatuses.FAILED : false;
  const collectionMap = useMemo(() => {
    if (!enabled || !gsFields) return EMPTY_MAP;
    return buildCollectionMap(gsFields, gsOverrides !== null && gsOverrides !== void 0 ? gsOverrides : {}, ['theme']);
  }, [enabled, gsFields, gsOverrides]);
  return {
    collectionMap,
    isLoading,
    isReady
  };
}